/* eslint-disable react/prop-types */
import React, {
  useState,
  // useRef
} from "react";
import SelectorBoxComponent from "./SelectorBoxComponent";
import PopoverComponent from "./PopoverComponent";

const CompetitorSelectorComponent = ({
  label,
  onChange,
  selectableOptions = [],
}) => {
  // const [actualSelection, setActualSelection] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  // const previousOption = useRef(actualSelection);

  const handleSelectClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleListItemClick = (e, option) => {
    // if (!e.detail || e.detail > 1) return;
    if (
      onChange
      // && previousOption.current.key
      // !== option.key
    ) {
      // previousOption.current = actualSelection;
      // setActualSelection(option);
      onChange(
        // previousOption.current,
        option
      );
    }
    setAnchorEl(null);
  };

  const handleOnClose = () => setAnchorEl(null);

  return (
    <>
      <SelectorBoxComponent label={label} handleClick={handleSelectClick} />
      <PopoverComponent
        anchorEl={anchorEl}
        handleClose={handleOnClose}
        options={selectableOptions}
        handleItemClick={handleListItemClick}
      />
    </>
  );
};

export default CompetitorSelectorComponent;
